import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Dropdown, Menu, Tooltip } from "antd";

const ButtonDownloadEInvoice = props => {
  const { documentId, filename, getDownload, isEinvoice, style } = props;

  return (
    <div style={style} onClick={e => e.stopPropagation()}>
      <Dropdown
        placement="bottomLeft"
        overlayStyle={{ zIndex: "99999", padding: 0 }}
        overlay={
          <Menu>
            <Menu.Item key="0">
              <div
                className={"gs-documents-download"}
                onClick={e =>
                  getDownload(
                    e, documentId, filename, "ASSOSW", isEinvoice
                  )
                }
              >
                SCARICA PDF
              </div>
            </Menu.Item>
            <Menu.Item key="1">
              <div
                className={"gs-documents-download"}
                onClick={e =>
                  getDownload(
                    e, documentId, filename, "XML", isEinvoice
                  )
                }
              >
                SCARICA XML
              </div>
            </Menu.Item>
          </Menu>
        }
      >
        <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={"Scarica documento"}>
          <div className="footer-einvoice-download-button" >
            <div onClick={e => e.preventDefault()}>
              <FontAwesomeIcon
                icon={["far", "arrow-to-bottom"]}
              />
            </div>
          </div>
        </Tooltip>
      </Dropdown>
    </div>
  );
};

export default ButtonDownloadEInvoice;
